riot.tag2('metadaten', '<div class="ui segment text grid"> <div class="sixteen wide column" if="{metaNow}"> <h3>Original-Metadaten:</h3> <div class="meta" if="{metaNow}"> Jetzt:<br> <strong>{metaNow.song}</strong> von <strong>{metaNow.artist}</strong></div> <div class="ui divider"></div> <div class="metanext" style="" if="{metaNext && debug}"> Es folgt:<br> {metaNext.song} von {metaNext.artist} </div> </div> </div> </div>', 'ul, li { list-style-type: none; padding-left: 0; }', '', function(opts) {
"use strict";

var _this = this;

var radio = opts.radio;
var channels = opts.channels;
var debugMsg = opts.debugMsg;
var debug = opts.debug;

this.metaNow = null;
this.metaNext = null;
this.metaAmazon = null;
this.metaItunes = null;
this.debug = debug;

radio.on("metadata", function (data) {
    debugMsg("[Event] meta - metadatentag");
    console.log(data);
    if (data.song) {
        var metadata = '';
        _this.metaNow = data;
        _this.metaAmazon = null;
        _this.metaItunes = null;

        data.meta.forEach(function (externalMeta) {
            console.log(externalMeta);
            if (externalMeta.type == "amazon") {
                _this.metaAmazon = externalMeta;
                if (externalMeta.largeimage) {
                    _this.metaNow.cover = externalMeta.largeimage;
                    $('body').css("background-image", "url(" + externalMeta.largeimage + ")");
                }
            } else if (externalMeta.type == "itunes") {
                _this.metaItunes = externalMeta;
                if (externalMeta.largeimage) {
                    _this.metaNow.cover = externalMeta.largeimage;
                    $('body').css("background-image", "url(" + externalMeta.largeimage + ")");
                }
            }
        });
    } else {
        _this.metaNow = data.rawdata;
    }

    _this.update();
});

radio.on("metanext", function (data) {
    opts.debugMsg("[Event] metanext");
    console.log(data);
    _this.metaNext = data;
    _this.update();
});
});



// WEBPACK FOOTER //
// ./src/js/elements/metadaten.tag